<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>upp-button-bar</h2>
            <p class="demo-description">Horizontal bar with equal-width buttons.</p>

            <div class="demo-controls">
                <ion-button size="small" (click)="toggleDisabled()">
                    Disabled: {{ disabled }}
                </ion-button>
            </div>

            <div class="demo-section">
                <h3>Default gap</h3>
                <upp-button-bar>
                    <upp-button-bar-item>
                        <ion-button size="small" [color]="active === 'day' ? 'primary' : 'light'" [disabled]="disabled" (click)="onSelect('day')">Day</ion-button>
                    </upp-button-bar-item>
                    <upp-button-bar-item>
                        <ion-button size="small" [color]="active === 'week' ? 'primary' : 'light'" [disabled]="disabled" (click)="onSelect('week')">Week</ion-button>
                    </upp-button-bar-item>
                    <upp-button-bar-item>
                        <ion-button size="small" [color]="active === 'month' ? 'primary' : 'light'" [disabled]="disabled" (click)="onSelect('month')">Month</ion-button>
                    </upp-button-bar-item>
                </upp-button-bar>
            </div>

            <div class="demo-section">
                <h3>Custom gap</h3>
                <upp-button-bar gap="8px">
                    <upp-button-bar-item>
                        <ion-button size="small" color="light" [disabled]="disabled">Income</ion-button>
                    </upp-button-bar-item>
                    <upp-button-bar-item>
                        <ion-button size="small" color="light" [disabled]="disabled">Products</ion-button>
                    </upp-button-bar-item>
                    <upp-button-bar-item>
                        <ion-button size="small" color="light" [disabled]="disabled">Activity</ion-button>
                    </upp-button-bar-item>
                    <upp-button-bar-item>
                        <ion-button size="small" color="light" [disabled]="disabled">Invoices</ion-button>
                    </upp-button-bar-item>
                </upp-button-bar>
            </div>
        </div>
    </upp-scrollable>
</div>
